import { Calculation } from 'final-form-calculate'
import { JustificativaCancelamentoAgendaComboEnum as JustificativaEnum } from 'types/enums'
import { MetaRoot } from 'util/metaPath'
import { CancelamentoAgendamentoModel } from 'view/agenda/model-agenda'

export const calculatorJustificativaCancelamento = (meta: MetaRoot<CancelamentoAgendamentoModel>): Calculation => ({
  field: meta.justificativa.absolutePath(),
  updates: {
    [meta.justificativaOutra.absolutePath()]: (
      justificativaValue: JustificativaEnum,
      allValues: CancelamentoAgendamentoModel
    ) => (justificativaValue === JustificativaEnum.OUTRA ? allValues.justificativaOutra : undefined),
  },
})
